import { Component, OnInit } from '@angular/core';
import { FormControl, FormRecord, Validators } from '@angular/forms';
import { AdsOrganization } from 'src/app/classes/ads-organization';
import { OrganizationService } from 'src/app/classes/organization.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import Countries from 'src/app/constants/countries';
import { environment } from 'src/environments/environment';
import Languages from 'src/app/constants/languages';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css']
})

export class OrganizationComponent implements OnInit {

  adsOrganization: AdsOrganization = new AdsOrganization()

  activeTab: string = 'basics'

  countries = Countries
  environment = environment
  fa = fa
  languages = Languages

  form = new FormRecord({
    name: new FormControl('', [Validators.required]),
    company_id: new FormControl('', [Validators.required]),
    vat_id: new FormControl(''),
    street_address: new FormControl('', [Validators.required]),
    office: new FormControl(''),
    postal_code: new FormControl('', [Validators.required]),
    city: new FormControl('', [Validators.required]),
    country: new FormControl(null, [Validators.required]),
    notes: new FormControl(''),
    display_name: new FormControl('', [Validators.required]),
  })

  constructor(
    private organizationService: OrganizationService,
    private router: Router,
    private httpClient: HttpClient
  ) {
    for(let language of environment.supported_languages) {
      this.form.addControl(`display_name_${language}`, new FormControl(''))
    }
  }
  
  ngOnInit(): void {
    this.organizationService.get().subscribe(adsOrganization => {
      this.adsOrganization = adsOrganization
      this.form.patchValue(adsOrganization)
    })
  }

  save() {
    this.organizationService.save(this.form.value).subscribe(() => {
      this.router.navigate(['/settings'])
    })
  }

  logoChange(event: any) {
    const file: File = event.target.files[0]

    if(file) {
      const formData = new FormData()
      
      formData.append('file', file, file.name)
      
      this.httpClient.post(`/api/media/organization/picture`, formData).subscribe(() => { 
        this.organizationService.get().subscribe(adsOrganization => {
          this.adsOrganization.picture = adsOrganization.picture
        })
      })

      event.target.value = null
    }
  }
}
